const atualizarMarcaEquipamentos = (state, marcaEquipamentos) => {
    state.marcaEquipamentos = marcaEquipamentos;
}

const atualizarMarcaEquipamento = (state, marcaEquipamento) => {
    state.marcaEquipamento = marcaEquipamento;
}

export default {
    atualizarMarcaEquipamentos,
    atualizarMarcaEquipamento
}